import { render } from "./edit.vue?vue&type=template&id=5c418937&scoped=true&ts=true"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"

import "./edit.vue?vue&type=style&index=0&id=5c418937&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c418937"]])

export default __exports__